import { Link } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";
import "./FraudTicker.css";

const COMPANY_NAME = import.meta.env.VITE_COMPANY_NAME;

const TickerMessage = ({ hidden }: { hidden?: boolean }) => (
  <div className="ep-ticker-item" aria-hidden={hidden}>
    <FaExclamationTriangle className="text-ep-gold" />
    <span className="ep-ticker-label">Beware of frauds:</span>
    <span>
      Always use our secure{" "}
      <Link
        to="/repay"
        className="ep-ticker-link"
        tabIndex={hidden ? -1 : undefined}
      >
        Repayment on Website Link
      </Link>{" "}
      for loan payments. Do not make direct bank payments to fake UPI links or
      unauthorised payment links. {COMPANY_NAME} is not responsible for
      payments made to other accounts.
    </span>
  </div>
);

const FraudTicker = () => {
  return (
    <>
      {/* reserves space so the fixed strip never covers the footer */}
      <div className="ep-ticker-spacer" />
      <div className="ep-ticker" role="marquee" aria-label="Fraud alert">
        <div className="ep-ticker-track">
          <TickerMessage />
          <TickerMessage hidden />
        </div>
      </div>
    </>
  );
};

export default FraudTicker;
